import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingQuote from "@/components/FloatingQuote";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ProductsPage from "@/pages/ProductsPage";
import IndustriesPage from "@/pages/IndustriesPage";
import QuotePage from "@/pages/QuotePage";
import ThankYouPage from "@/pages/ThankYouPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import QuoteDetailPage from "@/pages/QuoteDetailPage";
import PricingSettingsPage from "@/pages/PricingSettingsPage";
import ContactPage from "@/pages/ContactPage";
import BlogPage from "@/pages/BlogPage";
import BlogArticlePage from "@/pages/BlogArticlePage";
import GuidesIndexPage, { GuidePage } from "@/pages/GuidesPage";
import ScrollToTop from "@/components/ScrollToTop";
import SEOHead from "@/components/SEOHead";
import SchemaMarkup from "@/components/SchemaMarkup";
import { captureUTM } from "@/utils/utm";

function GuideRouteWrapper() {
  const { slug } = useParams();
  return <GuidePage slug={slug} />;
}

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    captureUTM();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      <SEOHead pathname={location.pathname} />
      <SchemaMarkup />
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/quote" element={<QuotePage />} />
        <Route path="/quote/thank-you" element={<ThankYouPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogArticlePage />} />
        <Route path="/guides" element={<GuidesIndexPage />} />
        <Route path="/guides/:slug" element={<GuideRouteWrapper />} />
        <Route path="/admin/login" element={<AdminLoginPage />} />
        <Route path="/admin" element={<AdminDashboardPage />} />
        <Route path="/admin/quotes/:id" element={<QuoteDetailPage />} />
        <Route path="/admin/pricing" element={<PricingSettingsPage />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
      <Footer />
      <FloatingQuote />
      <Toaster position="top-right" richColors />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
